// ############# GLOBAL FUNCTIONS: ##############

// RESIZE HANDLER:
function resizeHandler() {
  //console.log("window resized");
  headerCalcs();
  if ($(window).width() < 767) {
    //console.log("window small than 600");
  } else{
     
  }
}

// HEADER CALCULATIONS
function headerCalcs(){
  var headerHeight = $('#shopify-section-header').outerHeight();
  //console.log("header calcs called and headerHeight = " + headerHeight);
  //$('#shopify-section-header .js_search-ui-desktop').css({'top' : headerHeight + 'px'});
  //$('.js_mobile-menu').css({'height' : 'calc(100vh - ' + headerHeight + 'px'});
}

// STICKY HEADER
function stickyHeader(){
  if ( $('body').hasClass('has-announcement') ) {   
    var announcementHeight = 60;
    var scroll = $(window).scrollTop();
    //console.log("SCROLL POSITION = " + scroll);
    if (scroll >= announcementHeight) {
        $('body').addClass("scrolled-header");
        headerCalcs();   
    } else {
      $('body').removeClass("scrolled-header");
        headerCalcs();
    }
  }
}

// Fill in an empty Okendo ratings on the Shop All pages
function addEmptyStars() {
  const emptyStars = '<div class="oke-stars-background empty"><svg height="18" viewBox="0 0 79.22222222222221 14" aria-hidden="true"><use x="0" href="#oke-star-empty"></use><use x="16.155555555555555" href="#oke-star-empty"></use><use x="32.31111111111111" href="#oke-star-empty"></use><use x="48.46666666666667" href="#oke-star-empty"></use><use x="64.62222222222222" href="#oke-star-empty"></use></svg></div>';
  $('.okendo-stars').each(function(){
    if ( $(this).find('.oke-sr-rating').length < 1 ){
      $(this).find('.okeReviews.oke-sr').append(emptyStars);
      console.log('no rating found');
    }
  });
}

// ############# DOC READY! ##############
$(document).ready(function() {
  
// REMOVE NOJS
  $('html').removeClass('no-js').addClass('js');

// CALL RESIZE HANDLER:
  resizeHandler();

// CALL STICKY HEADER:
  stickyHeader();
  
// MATCH HEIGHT MANUAL INITS - extends matchheight in vendor.js:
  /*
  $(function() {
     $('.product-grid-item').matchHeight();

  });
  */

    setTimeout(function(){
    addEmptyStars();
  }, 620);

  setTimeout(function(){
     $('.swatch-wrap').children('.js_product-grid-variant-swatch:first').trigger('click').trigger('change');
    console.log('swatch-wrap');
  }, 300);


// HAMBURGER ANIMATION:
  $( ".hamburger, .hamburger-close" ).click(function() {
    $( this ).parent('.hamburger-wrap').toggleClass( "is-active" );
    $('.mobile-nav').toggleClass('open');
    if ($('.hamburger-wrap').hasClass('is-active')) {
      $('body').css('overflow', 'hidden');
    } else {
      $('body').css('overflow', '');
    }
  });

  
// TOGGLE BODY CLASS ON NAV OPEN:
  $( ".js-nav-control" ).click(function() {
      $('body').toggleClass('open');
  });

 
// OPEN EXTERNAL LINKS IN NEW WINDOW
  $(document.links).filter(function() {
    return this.hostname != window.location.hostname;
  }).attr('target', '_blank');
  

// SEARCH 

  $('.js_search-close').on("click", function(e) {
    e.preventDefault();
    $('.js_search-ui').hide();
  });
  
  $('.js_desktop-search-trigger').on("click", function(e) {
    if($('.js_search-ui-desktop').is(":visible")) {
      $('.js_search-ui-desktop').hide();
    } else {
      $('.js_search-ui-desktop').fadeToggle('200').find('input').focus();
      e.stopPropagation();
      e.preventDefault();
    }
  });

  
// QTY ADJUST
  jQuery(function(){
    var j = jQuery; 
    var addInput = '.js-qty-wrap'; 

    j(addInput).each(function() { 
      var inputEl = j(this).closest(addInput).find('input');
      var n = inputEl.val(); 
      var plusEl = j(this).closest(addInput).find('.plus');
      var minEl = j(this).closest(addInput).find('.min');
      //On plus click add 1 to n
      plusEl.on('click', function(){
        inputEl.val(++n);
      });
      //On min click 
      minEl.on('click', function(){
      //If n is bigger or equal to 1 subtract 1 from n 
        if ( ( inputEl.val() ) > 1) {
          inputEl.val(--n);
        } 
      });
    });
  });

  
/* ===== VIDEOS =====  */
    /* ########## PLYR VIDEOS - extends plyr.js ############ */
  $( '.videoplayer' ).each( function() {
    const player = new Plyr(this, {
      hideControls: true
    });
  });
  
  $('.plyr').each( function(player) { 
    $(this).on('play',function(){ 
      $('.plyr--playing').not(this).trigger('click'); // clicking a playing player will pause it, so trigger that
    });
  });
  
  
  
// SLIDER GRID ITEM: CHANGE IMAGE WITH VARIANT CHANGE
  $('.js_slider-grid-variant-swatch').on('change', function() {
    var parent = $(this).closest('.js_slider-grid-item');    
    var selected = parent.find('.js_slider-grid-variant-swatch:checked');
    var variantID = selected.data('variant-id');
    var variantImage = selected.data('variant-image');
    // ### update image sliders based on selected:
    var position = -1;
    parent.find('.js_slider-grid-variant-thumb').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });       
    if ( position != -1 ) { 
      parent.find('.js_slider-grid-variant-slider').slick('slickGoTo', position);
    }
  });

// PRODUCT GRID ITEM: CHANGE IMAGE, PRICE WITH VARIANT CHANGE
  // radio (swatch)
  $('.js_product-grid-variant-swatch').on('change', function() {

    var parent = $(this).closest('.js_product-grid-item');    
    var shadowSelect = parent.find('.js_swatchShadowSelect');
    var selected = parent.find('.js_product-grid-variant-swatch:checked');
    var variantID = selected.data('variant-id');
    var variantPrice = selected.data('variant-price');
    var variantPriceValue = selected.data('variant-price-value');
    var variantPriceCompare = selected.data('variant-price-compare');
    var variantPriceCompareValue = selected.data('variant-price-compare-value');
    var variantImage = selected.data('variant-image');
    var variantAvailable = selected.data('variant-available');
    var thresholdPrice = variantPriceCompareValue * .73;

    
/*
    console.log("js_product-grid-variant-swatch CHANGED");
    console.log("the new variant ID = " + variantID);
    console.log("the new variant price = " + variantPrice);
    console.log("the new variant compare price = " + variantPriceCompare);
    console.log("the new variant image id = " + variantImage);  
    console.log("the new variant availability = " + variantAvailable);  
*/
    // ### update linked select menu:
    shadowSelect.val(variantID).change();
    // ### update price based on selected:
    parent.find('.js-product-grid-price').text(variantPrice);
    // ### update compare price based on selected, but only show if it's greater than normal price:
    if (thresholdPrice > variantPriceValue) {
      parent.find('.js-product-grid-compare-price').text(variantPriceCompare);
      parent.find('.js-product-grid-price').css('color', '#d93438');
    } else {
      parent.find('.js-product-grid-compare-price').text('');
      parent.find('.js-product-grid-price').css('color', '');
    }
    // ### update image sliders based on selected:
    var position = -1;
    parent.find('.js_product-grid-variant-thumb').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });       
    if ( position != -1 ) { 
      parent.find('.js_product-grid-variant-slider').slick('slickGoTo', position);
    }
    // ### update button based on selected:
    if (variantAvailable === 1 ){
      //console.log("Product is available");
      parent.find('.js_add-to-cart').show();
      parent.find('.js_sold-out-link').hide();
    } else if (variantAvailable === 0 ){
      //console.log("Product is sold out");
      const soldOutUrl = parent.find('.js_sold-out-link').attr('href');
      parent.find('.js_add-to-cart').hide();
      // parent.find('.js_add-to-cart').text('Sold Out');
      parent.find('.js_sold-out-link').attr('href', soldOutUrl );
      parent.find('.js_sold-out-link').attr( 'data-variant-id', variantID );
      parent.find('.js_sold-out-link').show();
    }
  });

  // When Clicking the View More Button (Sold Out Product)
  $(document).on('click', '.js_sold-out-link', function(e){
    e.preventDefault();
    const variantId = $(this).attr('data-variant-id'), currentUrl = $(this).attr('href');
    window.location.href = currentUrl + '?variant=' + variantId;

  });

    // PDP - Replace Sold Out button with Klaviyo 'Notify' modal link
  if ( $('body').attr('data-template') === 'product' ){
    // Check initial stock
    const initialAvailability = parseInt($('.pdp-variant-swatches input:checked').attr('data-variant-available'));
    if ( initialAvailability === 0 ){
      $('.pdp-buttons button.cta').hide();
      $('.pdp-buttons a.klaviyo-bis-trigger').css('display', 'block');
      $('.pdp-buttons a.klaviyo-bis-trigger').removeClass('d-none');
    }
    else {
      $('.pdp-buttons button.cta').show();
      $('.pdp-buttons a.klaviyo-bis-trigger').addClass('d-none');
    }
    $(document).on('change', '.pdp-variant-swatches input[type="radio"]', function(){
      const variantAvailable = $(this).attr('data-variant-available');
      if ( parseInt(variantAvailable) === 0 ){
        $('.pdp-buttons button.cta').hide();
        $('.pdp-buttons a.klaviyo-bis-trigger').css('display', 'block');
        $('.pdp-buttons a.klaviyo-bis-trigger').removeClass('d-none');
      }
      else {
        $('.pdp-buttons button.cta').show();
        $('.pdp-buttons a.klaviyo-bis-trigger').addClass('d-none');
      }
    });
  }

  // select menu (dropdown)
  $('.js_product-grid-variant-select').on('change', function() {

    var parent = $(this).closest('.js_product-grid-item');    
    var selected = parent.find(':selected'); 
    var variantID = selected.data('variant-id');
    var variantPrice = selected.data('variant-price');
    var variantPriceCompare = selected.data('variant-price-compare');
    var variantAvailable = selected.data('variant-available');
/*
    console.log("js_product-grid-variant-select CHANGED");
    console.log("the new variant ID = " + variantID);
    console.log("the new variant price = " + variantPrice);
    console.log("the new variant compare price = " + variantPriceCompare);
    console.log("the new variant availability = " + variantAvailable);  
*/
    // ### update price based on selected:
    parent.find('.js-product-grid-price').text(variantPrice);
    // ### update compare price based on selected, but only show if it's greater than normal price:
    if (variantPriceCompare > variantPrice) {
      parent.find('.js-product-grid-compare-price').text(variantPriceCompare);
    } else {
      parent.find('.js-product-grid-compare-price').text('');
    }
    // ### update image sliders based on selected:
    var position = -1;
    parent.find('.js_product-grid-variant-thumb').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });       
    if ( position != -1 ) { 
      parent.find('.js_product-grid-variant-slider').slick('slickGoTo', position);
    }
    // ### update button based on selected:
    if (variantAvailable === 1 ){
      //console.log("Product is available");
      parent.find('.js_product-grid-button').prop('disabled', false);
      parent.find('.js_add-to-cart').text('Add To Cart');
    } else if (variantAvailable === 0 ){
      //console.log("Product is sold out");
      parent.find('.js_product-grid-button').prop('disabled', true);
      parent.find('.js_add-to-cart').text('Sold Out');
    }

  });
  
  
  
// ***** SLICK SLIDERS: ***** 
  
  // PRODUCT SLIDER
  $(".js_product-slider").each(function () {
    var slider = $(this);
  
    slider.slick({
      slidesToShow: 3,
      slidesToScroll:1,
      appendArrows: slider.next('.js_product-slider-arrows'),
      prevArrow: "<a href='#' class='previous-arrow'><i class='fa-light fa-chevron-left slider-arrow slider-arrow-prev'></i></a>",
      nextArrow: "<a href='#' class='next-arrow'><i class='fa-light fa-chevron-right slider-arrow slider-arrow-next'></i></a>",
      infinite:true,
      dots:true,
      responsive: [     
        {
          breakpoint: 1599,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  });
  
    // PRODUCT GRID ITEM - VARIANT IMAGES (COLLECTION)
    $(".js_product-grid-variant-slider").each(function () {
    var slider = $(this);
  
    slider.slick({
      slidesToShow: 1,
      slidesToScroll:1,
      arrows:false,
      infinite:false,
      dots:false,
      draggable:false,
      swipe:false,
      touchMove:false,
      fade:true
    });
  });

  // SLIDER GRID ITEM - VARIANT IMAGES
    $(".js_slider-grid-variant-slider").each(function () {
    var slider = $(this);
  
    slider.slick({
      slidesToShow: 1,
      slidesToScroll:1,
      arrows:false,
      infinite:false,
      dots:false,
      draggable:false,
      swipe:false,
      touchMove:false,
      fade:true
    });
  });
  
    
  // CIRCLE SLIDER
  $(".js_circle-slider").each(function () {
    var slider = $(this);
  
    slider.slick({
      slidesToShow: 6,
      slidesToScroll:1,
      prevArrow:$('#circle-slider-prev-arrow'),
      nextArrow:$('#circle-slider-next-arrow'),
      infinite:true,
      dots:false,
      responsive: [     
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 576,
          settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '25%',
          }
        }
      ]
    });
  });
  
  // PDP CAROUSEL WITH THUMBS
    $('.js-slider-primary').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: "<a href='#' class='previous-arrow'><i class='fa-light fa-chevron-left slider-arrow slider-arrow-prev'></i></a>",
      nextArrow: "<a href='#' class='next-arrow'><i class='fa-light fa-chevron-right slider-arrow slider-arrow-next'></i></a>",
      fade: true,
      infinite:true,
      asNavFor: '.js-slider-thumbs'
    });

    $('.js-slider-thumbs').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.js-slider-primary',
      dots: false,
      // adaptiveHeight: true,
      centerMode: false,
      cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
      draggable: true,
      focusOnSelect: true,
      useTransform: true,
      infinite: true,
      // variableWidth: true,
      arrows: true,
      prevArrow: "<a href='#' class='previous-arrow'><i class='fa-light fa-chevron-left slider-arrow slider-arrow-prev'></i></a>",
      nextArrow: "<a href='#' class='next-arrow'><i class='fa-light fa-chevron-right slider-arrow slider-arrow-next'></i></a>",
      responsive: [     
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            focusOnSelect: true,
            useTransform:false,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
            focusOnSelect: true,
            useTransform:false,
            slidesToScroll: 1,
          }
        }
      ]
    });
    var $videoActive = false;
    $('.js-slider-primary').on('afterChange', function(event, slick, currentSlide){
      if ( $('.js-slider-primary .slick-slide').eq(currentSlide).hasClass('product-single__video') ) {
        $(this).find('video').get(0).play();
        $videoActive = true;
      } else if($videoActive) {
        $('.js-slider-primary .product-single__video').each(function(){
          $(this).find('video').get(0).pause();
        });
        $videoActive = false;
      }
    });

      var position = -1;
var parent = $('.js_pdp-variant-swatch').closest('.js_pdp-single');    
var selected = parent.find('.js_pdp-variant-swatch:checked');
var variantID = selected.data('variant-id');
var variantImage = selected.data('variant-image');
  parent.find('.js_single-photo').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        //console.log("SINGLE IMAGE MATCH";
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });

// console.log("Variant Image Selected: " + selected);
// console.log("Variant Image ID: " + variantID);
// console.log("Variant Image Image: " + variantImage);
// console.log("Variant Image Position: " + position);

  if ( position != -1 ) { 
      parent.find('.js-slider-thumbs').slick('slickGoTo', position);
    }
  
// PDP: CHANGE IMAGE, PRICE, CONTENT WITH VARIANT CHANGE
  
  
// radio (swatch)
$('.js_pdp-variant-swatch').on('change', function() {

    var parent = $(this).closest('.js_pdp-single');    
    var selected = parent.find('.js_pdp-variant-swatch:checked');
    var shadowSelect = parent.find('.js_swatchShadowSelect');
    var variantID = selected.data('variant-id');
    var variantPrice = selected.data('variant-price');
    var variantPriceValue = selected.data('variant-price-value');
    var variantPriceCompare = selected.data('variant-price-compare');
    var variantPriceCompareValue = selected.data('variant-price-compare-value');
    var variantPriceSavings = "$" + ( (variantPriceCompareValue - variantPriceValue) / 100).toFixed(2);
    var variantImage = selected.data('variant-image');
    var variantAvailable = selected.data('variant-available');
    var variantLabel = selected.data('variant-title');
    var thresholdPrice = variantPriceCompareValue * .73;

    // change sku number when variant changes
    $('div[data-variant-switch="group"]').each(function() {
      $( this ).find('div[data-variant-switch="single"][data-variant-id="' + variantID +'"').addClass('active').siblings('div[data-variant-switch="single"]').removeClass('active');
    });
  
/*
    console.log("js_pdp-variant-swatch CHANGED");
    console.log("the new variant ID = " + variantID);
    console.log("the new variant price = " + variantPrice);
    console.log("the new variant compare price = " + variantPriceCompare);
    console.log("the new variant compare savings = " + variantPriceSavings);
    console.log("the new variant image id = " + variantImage);  
    console.log("the new variant availability = " + variantAvailable);  
*/
    // ### update linked select menu:
    shadowSelect.val(variantID).change();
    // ### update label based on selected:
    parent.find('.js-color-label').text(variantLabel);
    // ### update price based on selected:
    parent.find('.js-pdp-price').text(variantPrice).append("\u00A0");
    // ### update compare price based on selected, but only show if it's greater than normal price:
    if (thresholdPrice > variantPriceValue) {
      $('.savings-container').css('display', 'block');
      parent.find('.js-pdp-compare-price').text(variantPriceCompare);
      parent.find('.js_savings-message').text('You Save ');
      parent.find('.js_pdp-savings').text(variantPriceSavings);      
    } else {
      $('.savings-container').css('display', 'none');
      parent.find('.js-pdp-compare-price').text('');
      parent.find('.js_compare-price-savings span').text('');
    }
    // ### update image sliders based on selected:
    var position = -1;
    parent.find('.js_single-photo').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        //console.log("SINGLE IMAGE MATCH");
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });         
    if ( position != -1 ) { 
      parent.find('.js-slider-thumbs').slick('slickGoTo', position);
    }
    // ### update button based on selected:
    if (variantAvailable === 1 ){
      //console.log("Product is available");
      parent.find('.js_pdp-form-btn').prop('disabled', false).text('Add To Cart');
    } else if (variantAvailable === 0 ){
      //console.log("Product is sold out");
      parent.find('.js_pdp-form-btn').prop('disabled', true).text('Sold Out');
    }
  });

  // select menu (dropdown)
  $('.js_pdp-variant-select').on('change', function() {

    var parent = $(this).closest('.js_pdp-single');    
    var selected = parent.find('.js_pdp-variant-select:selected'); 
    var variantID = selected.data('variant-id');
    var variantPrice = selected.data('variant-price');
    var variantPriceValue = selected.data('variant-price-value');
    var variantPriceCompare = selected.data('variant-price-compare');
    var variantPriceCompareValue = selected.data('variant-price-compare-value');
    var variantPriceSavings = "$" + ( (variantPriceCompareValue - variantPriceValue) / 100).toFixed(2);
    var variantImage = selected.data('variant-image');
    var variantAvailable = selected.data('variant-available');

   // console.log("js_pdp-variant-select CHANGED");
   // console.log("the new variant ID = " + variantID);
   // console.log("the new variant price = " + variantPrice);
  // console.log("the new variant compare price = " + variantPriceCompare);
   // console.log("the new variant compare savings = " + variantPriceSavings);
   // console.log("the new variant image id = " + variantImage);  
   // console.log("the new variant availability = " + variantAvailable);  

    // ### update price based on selected:
    parent.find('.js-pdp-price').text(variantPrice);
    // ### update compare price based on selected, but only show if it's greater than normal price:
    if (variantPriceCompare > variantPrice) {
      parent.find('.js-pdp-compare-price').text(variantPriceCompare);
      parent.find('.js_savings-message').text('You Save ');
      parent.find('.js_pdp-savings').text(variantPriceSavings);      
    } else {
      parent.find('.js-pdp-compare-price').text('');
      parent.find('.js_compare-price-savings span').text('');
    }
    // ### update image sliders based on selected:
    var position = -1;
    parent.find('.js_single-photo').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        // console.log("SINGLE IMAGE MATCH");
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });            
    if ( position != -1 ) { 
      parent.find('.js-slider-thumbs').slick('slickGoTo', position);
    }
    // ### update button based on selected:
    if (variantAvailable === 1 ){
      //console.log("Product is available");
      parent.find('.js_pdp-form-btn').prop('disabled', false).text('Add To Cart');
    } else if (variantAvailable === 0 ){
      //console.log("Product is sold out");
      parent.find('.js_pdp-form-btn').prop('disabled', true).text('Sold Out');
    }
  });
  
  
  // Detect the variant URL param, display variant images on load
  function checkUrlForVariant(){
    console.log('checkUrlForVariant');
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const variant = urlParams.get('variant');
    if ( variant !== null ){
      console.log('var found ' + variant);
      const $variantSwatches = $('fieldset.pdp-variant-swatches');
      // setTimeout(function(){
      //   console.log('var first');
      //   $variantSwatches.find('.js_pdp-variant-swatch').first().trigger('click').trigger('change');
      // }, 500);
      setTimeout(function(){
        $('input.js_pdp-variant-swatch[data-variant-id="' + variant + '"]').trigger('click').trigger('change');
        console.log('var second');
      }, 1400);

    }
  }
  checkUrlForVariant();

  // Redirect user after create_customer 
  function redirectNewCustomer(){
    const REDIRECT_PATH = '/account'; 
   
     const selector = '#create_customer, form[action$="/account"][method="post"]', 
         $form = document.querySelectorAll(selector)[0]; 
   
     if ($form) { 
       $redirect = document.createElement('input'); 
       $redirect.setAttribute('name', 'return_to'); 
       $redirect.setAttribute('type', 'hidden'); 
       $redirect.value = REDIRECT_PATH; 
       $form.appendChild($redirect); 
     } 
     console.log('redirectNewCustomer');
  }

  if ( $('body#create-account') ){
    redirectNewCustomer();
  }



// ############# END DOC READY! ##############
});
// ############# END DOC READY! ##############


// ############# RESIZE EVENT: ##############
$(window).resize(resizeHandler);

// ############# SCROLL EVENT: ##############
$(window).scroll(stickyHeader);
